import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
const StandardDeviation = ({ xScale, yScale, point, dataSerie, trendData, getPointColor })=>{
    const timestamp = point.x;
    const value = point.y;
    const stdDev = trendData.standardDeviations[timestamp];
    if (!value || !stdDev) {
        return null;
    }
    const color = getPointColor(dataSerie);
    const x = xScale(timestamp);
    const lineTop = yScale(value - stdDev / 2);
    const lineBottom = yScale(value + stdDev / 2);
    return /*#__PURE__*/ _jsxs("g", {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: x,
                y1: lineTop,
                x2: x,
                y2: lineBottom,
                style: {
                    stroke: color,
                    strokeWidth: 2
                }
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: x - 3,
                y1: lineTop,
                x2: x + 3,
                y2: lineTop,
                style: {
                    stroke: color,
                    strokeWidth: 2
                }
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: x - 3,
                y1: lineBottom,
                x2: x + 3,
                y2: lineBottom,
                style: {
                    stroke: color,
                    strokeWidth: 2
                }
            })
        ]
    }, x);
};
export default StandardDeviation;
